import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { FeatureFlag } from '../models/feature-flag.model';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FeatureFlagService {
    private httpClient = inject(HttpClient);

    public getFeatureFlags(): Observable<FeatureFlag> {
        return this.httpClient.get<FeatureFlag>(`${environment.apiUrl}/settings/feature-flags`).pipe(
            catchError((error) => {
                console.error(error);
                throw error;
            })
        );
    }
}
